exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".VolumeAccountColumns div h5 {\n  border-bottom: 5px solid #4392f1;\n  margin-bottom: 1rem; }\n\n.VolumeAccountColumns div .emptyFormGroup {\n  height: 47px; }\n\n.EqualsLine {\n  border-bottom: 2px solid #4392f1; }\n\ntr.topRowInnerTable th {\n  border-top: none !important; }\n\ntr.topRowInnerTable th:first-of-type {\n  border-left: none !important; }\n\ntr.topRowInnerTable th:last-of-type {\n  border-right: none !important; }\n\ntr.bottomRowInnerTable td {\n  border-bottom: none !important; }\n\ntr.bottomRowInnerTable td:first-of-type {\n  border-left: none !important; }\n\ntr.bottomRowInnerTable td:last-of-type {\n  border-right: none !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Components/Main/TestWorkflow/Inventory/VolumeAccounting/VolumeAccounting.scss
// module id = 481
// module chunks = 0